import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { FtoReportAdjustTechFeaturesService } from '../adjust-tech-features-service';
import type { TechFeature } from '../../types';
import { CurrentTaskService } from '@/services/current-task/current-task-service';
import { FtoReportTechFeatureSubmitApi } from '../../apis/tech-feature-submit-api';

@injectable()
export class FtoReportAdjustTechFeaturesServiceImpl implements FtoReportAdjustTechFeaturesService {
    constructor(
        @inject(FtoReportTechFeatureSubmitApi)
        private readonly _techFeatureSubmitApi: FtoReportTechFeatureSubmitApi,
        @inject(CurrentTaskService)
        private readonly _currentTaskService: CurrentTaskService,
    ) {}

    async adjust(techFeatures: TechFeature[]): Promise<void> {
        const taskId = this._currentTaskService.taskId;
        const data = await this._submitTechFeaturesRepository(taskId, techFeatures);
        return data;
    }

    private _submitTechFeaturesRepository(taskId: string, techFeatures: TechFeature[]): Promise<void> {
        return this._techFeatureSubmitApi.submitTechFeature({
            task_id: taskId,
            tech_features: techFeatures.map((feature) => ({
                tech_feature: feature.name,
                core: !!feature.flagged,
                user_add: !!feature.manualAdded,
            })),
        });
    }
}
